import clsx from 'clsx';
import { InfoIcon } from '../icons-library/info';

type ShowpadDelayInfoBoxProps = {
    text: string;
    withoutPadding?: boolean;
};

export const ShowpadDelayInfoBox = (props: ShowpadDelayInfoBoxProps) => {
    return (
        <div
            class={clsx(
                'flex items-center gap-3 rounded-medium bg-cvi-bg-status-highlight text-cvi-fg-default',
                !props.withoutPadding && 'p-6'
            )}
        >
            <InfoIcon
                width={2.55}
                height={2.55}
                stroke="currentColor"
                class="text-cvi-fg-muted shrink-0"
            />
            <div class="label-md font-cvi-regular">{props.text}</div>
        </div>
    );
};
